export function AvatarView({ student, size = 80, className = "", faded = false, plain = false }) {
  const cz = (student && student.customization) || {};
  const base = cz.base_image || student?.avatar;
  const frameColor = cz.frame_color || "#FFFFFF";
  const equip = cz.equip_image; // customizable → behind body
  const perso = cz.perso_image;  // personalización → in front
  const frameImg = cz.frame_image;
  // backward compat: old multi-accessory list rendered in front
  const legacy = Array.isArray(cz.accessories) ? cz.accessories : [];

  return (
    <div className={`relative ${faded ? "grayscale opacity-50" : ""} ${className}`} style={{ width: size, height: size }}>
      {equip && <img src={equip} alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none z-0" />}
      <div className="absolute inset-0 rounded-2xl overflow-hidden z-10" style={plain ? { background: "transparent" } : { background: "#fff", boxShadow: `0 0 0 3px ${frameColor}` }}>
        <img src={base} alt="" className="w-full h-full object-cover" />
      </div>
      {perso && <img src={perso} alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none z-20" />}
      {legacy.map((a, i) => (<img key={i} src={a} alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none z-20" />))}
      {!plain && frameImg && <img src={frameImg} alt="" className="absolute inset-0 w-full h-full object-contain pointer-events-none z-30 scale-110" />}
    </div>
  );
}
